import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";

type EligibilityState = {
  condition: string | null;
  medication: string | null;
  denialReason: string | null;
};

type EligibilityContextValue = {
  eligibility: EligibilityState;
  setEligibility: Dispatch<SetStateAction<EligibilityState>>;
};

type EligibilityProviderProps = {
  children: ReactNode;
};

const EligibilityContext = createContext<EligibilityContextValue | null>(null);

export const EligibilityProvider = ({ children }: EligibilityProviderProps) => {
  const [eligibility, setEligibility] = useState<EligibilityState>({
    condition: null,
    medication: null,
    denialReason: null,
  });

  const value = useMemo(
    () => ({
      eligibility,
      setEligibility,
    }),
    [eligibility],
  );

  return (
    <EligibilityContext.Provider value={value}>
      {children}
    </EligibilityContext.Provider>
  );
};

export const useEligibility = () => {
  const eligibilityContext = useContext(EligibilityContext);

  if (eligibilityContext === null) {
    throw new Error(
      "useEligibility must be used within an EligibilityProvider",
    );
  }

  return eligibilityContext;
};
